import React from 'react';
import Attribution from './Attribution';
import Card from './Card';
import QuoteAvatar from './QuoteAvatar';
import { cn } from '@/lib/twUtils';

export interface TestimonialProps {
  quote: string;
  name: string;
  /** Mestiere, di fianco al nome */
  role?: string;
  /** Ragione sociale dello studio */
  company?: string;
  /** Iniziali mostrate nel cerchio quando manca la foto */
  initials: string;
  /** Foto quadrata del professionista: quando c'è, prende il posto delle iniziali */
  image?: string;
  tone?: 'paper' | 'mist' | 'accent';
  className?: string;
}

/** Citazione di un cliente, con attribuzione. Una sola `accent` per griglia. */
const Testimonial = ({
  quote,
  name,
  role,
  company,
  initials,
  image,
  tone = 'paper',
  className,
}: TestimonialProps) => {
  const onAccent = tone === 'accent';

  return (
    <Card
      tone={tone}
      padding="sm"
      // L'attribuzione sta subito sotto la citazione, non in fondo alla card:
      // in una griglia la card più corta lascerebbe il nome a mezz'aria.
      className={cn('justify-start gap-5 p-[1.875rem]', className)}
    >
      <blockquote
        className={cn(
          'ds-quote text-[1.0625rem] leading-[1.55] font-light italic',
          onAccent ? 'text-white' : 'text-primary'
        )}
      >
        {/* Virgolette decorative: più grandi del testo, in tondo pesante,
            appese sopra la riga come nella grafica di riferimento. */}
        <span
          aria-hidden
          className="mr-1.5 inline-block align-[-0.35em] font-display text-[1.9em] leading-[0] font-semibold not-italic"
        >
          &ldquo;
        </span>
        {quote}
        <span
          aria-hidden
          className="ml-1 inline-block align-[-0.35em] font-display text-[1.9em] leading-[0] font-semibold not-italic"
        >
          &rdquo;
        </span>
      </blockquote>
      <figcaption className="flex items-center gap-3">
        <QuoteAvatar image={image} initials={initials} onDark={onAccent} />
        <Attribution name={name} role={role} company={company} onDark={onAccent} />
      </figcaption>
    </Card>
  );
};

export default Testimonial;
